// extracted by mini-css-extract-plugin
export default {"rowBlock":"GridThreeElems_rowBlock__vRezh","rowBlockElem":"GridThreeElems_rowBlockElem__6yUt9","title":"GridThreeElems_title__nUjeK","text":"GridThreeElems_text__TBSm0"};